import React from 'react';
import { getAssetPath } from '../utils/paths';

const Features = () => {
  const features = [
    {
      icon: getAssetPath('/Helax/assets/img/icon/ft_01.svg'),
      title: 'Dynamic Wallet Scoring System Continuously Scanning the Ecosystem',
      description: 'A constantly updated contribution & loyalty scoring system that analyzes all user behavior on the network in real time. Not a one-time event; a permanent infrastructure that measures long-term ecosystem loyalty'
    },
    {
      icon: getAssetPath('/Helax/assets/img/icon/ft_02.svg'),
      title: 'Verifiable Tagging Infrastructure That Highlights Loyal Users',
      description: 'A transparent and tamper-proof tagging model that identifies wallets that genuinely support the ecosystem. This allows projects to easily distinguish real users from fake activity.'
    },
    {
      icon: getAssetPath('/Helax/assets/img/icon/ft_03.svg'),
      title: 'A “Contribution Layer” That Delivers the Most Valuable Users to Every Project',
      description: 'The infrastructure that enables new projects, campaigns, or collaborations to reach the highest-quality and most loyal user base directly. Nova Verse acts as the premium user filter for the entire ecosystem.'
    },
    {
      icon: getAssetPath('/Helax/assets/img/icon/ft_04.svg'),
      title: 'A Sustainable and Continuously Updated Support Model',
      description: 'NovaVerse continuously tracks and updates the wallets that actively support the Solana ecosystem. This is not a one time system it’s a long term model designed to highlight real, ongoing contributors and keep the ecosystem informed.'
    },
    {
      icon: getAssetPath('/Helax/assets/img/icon/ft_05.svg'),
      title: 'Multi-Layered Incentive Economy with Badges, Scores, and Status Levels',
      description: 'Badge and status systems that will show users contribution levels are being developed. This system creates a powerful filter for projects and a reputation economy for users.'
    },
    {
      icon: getAssetPath('/Helax/assets/img/icon/ft_06.svg'),
      title: 'Ecosystem Map Adding Value to Partnerships',
      description: 'Thanks to Nova Verse , projects can easily identify their target user segments : Active , Loyal ,Long-term supporter ,Historical contributor'
    },
    {
      icon: getAssetPath('/Helax/assets/img/icon/ft_07.svg'),
      title: 'Advanced Scoring Engine with Anti-Manipulation Robust Infrastructure',
      description: 'Nova Verse uses an advanced behavioral analysis engine to detect fake activities, bot behavior, and short-term farming attempts. This ensures that only users who make genuine contributions rise, creating the most reliable and cleanest user pool for projects.',
      large: true
    }
  ];

  return (
    <section id="feature" className="crm-feature pos-rel pt-70 pb-140">
      <div className="container">
        <div className="crm-feature__title text-center mb-60">
          Powerful features
        </div>
        <div className="row justify-content-center mt-none-20">
          {features.map((feature, index) => (
            <div
              key={index}
              className={feature.large ? "col-lg-6 col-md-12 mt-20" : "col-lg-3 col-md-6 mt-20"}
            >
              <div className="crm-feature__item">
                <div className="icon mb-40">
                  <img src={feature.icon} alt={feature.title} />
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
                {feature.extraIcon && (
                  <div className="ft_icon">
                    <img src={feature.extraIcon} alt="" />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="crm-feature__shape">
        <div className="shape shape--1" data-parallax='{"y" : 70}'>
          <img src={getAssetPath('/Helax/assets/img/shape/ft_shape1.png')} alt="" />
        </div>
        <div className="shape shape--2" data-parallax='{"y" : 80}'>
          <img src={getAssetPath('/Helax/assets/img/shape/ft_shape2.png')} alt="" />
        </div>
      </div>
    </section>
  );
};

export default Features;

